import React, { useEffect } from 'react'
import { StyleSheet, css } from 'aphrodite'
import { useState } from 'react'
import ReactDOM from 'react-dom'
import { ApiHelper } from '../../common/helpers/ApiHelper'
import { Helper } from '../../common/helpers/Helper'
import { CbSelection } from '../../common/components/CbSelection';
import { cbSource } from '../../data/data'
import { AppTheme } from '../../styles/AppTheme'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { AppConfig } from '../../AppConfig'
import { Tooltip } from '@material-ui/core'
import { AppButton } from '../../common/components/AppButton'
const uuid = require('uuid');

const theme = createMuiTheme({
  palette: {
    primary: {
      main: AppTheme.primaryColor
    },
    secondary: {
      main: AppTheme.secondaryColor
    }
  },
  typography: {
    fontFamily: [
      AppConfig.GFONTNAME
    ].join(',')
  }
});

const ReactComponent = (props) => {
  const [blockSelectionModal, setblockSelectionModal] = useState(false)
  const [blocks, setBlocks] = useState([])
  const [selectedBlock, setBlock] = useState(null)

  useEffect(() => {
    setBlocks(props.cbs)
    setblockSelectionModal(true)
  }, [])

  const doActionNext = (selectedBlockSource, selectedBlockType, selectedBlock) => {
    setblockSelectionModal(false)
    setBlock(selectedBlock)
    props.setCbId(selectedBlock.id)
  }

  const getTitle = (cbId) => {
    for (const block of blocks) {
      if (block.id === cbId) return block.title
    }
  }

  const openNewWindow = () => {
    window.open('/admin/orgs/' + props.orgId + '/preview?ppath=' + props.previewPath, 'slixtaPreivew');
  }

  const renderCb = () => {
    return (
      <CbSelection
        selectedBlock={'SITE'}
        title={Helper.getString('blockSelection')}
        isOpen={blockSelectionModal}
        onClosed={() => setblockSelectionModal(false)}
        cbSite={{ items: blocks }}
        doActionNext={doActionNext}
        cbSource={cbSource}
        hideBlockSelector={true}
      />
    )
  }

  if (props.cbId) {
    return (
      <div className={css(Styles.container)}>
        <p>{getTitle(props.cbId)}</p>
        <Tooltip title={Helper.getString('preview')}>
          <i onClick={() => openNewWindow()} className='material-icons-outlined' style={{ fontSize: 18, marginLeft: 10, fontStyle: 'normal', cursor: 'pointer' }}>desktop_windows</i>
        </Tooltip>
      </div>
    )
  }

  return (
    <div>
      {selectedBlock ?
        <div className={css(Styles.container)}>
          <p>{selectedBlock.title}</p>
        </div>
        :
        <div className={css(Styles.container)}>
          <AppButton
            onClick={() => setblockSelectionModal(true)}
            buttonText={Helper.getString('blockSelection')}
          />
        </div>
      }
      {blockSelectionModal && renderCb()}
    </div>
  )
}

export default class SlixtaWidget {
  constructor({ data, api, config }) {
    // provided by EditorJS
    this.api = api
    this.config = config
    this.data = data
    this.container = undefined
    this.cbId = data.cbId || null
    this._CSS = {
      block: this.api.styles.block,
      react: 'react-component',
    }
    this.blockId = uuid()
  }

  static get toolbox() {
    return {
      title: 'Slixta Widgets',
      icon: `<svg width="118" height="40" viewBox="0 0 752.6 188" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="#122E79" d="M96.2,109.4c-7.1-2.7-16.3-5.5-27.3-8.1c-10.5-2.4-18.3-4.8-23.2-7.2c-5.7-2.8-8.6-7-8.6-12.7 c0-4.9,1.6-8.7,4.8-11.4c3.1-2.6,7.5-4,13.1-4c7,0,13,2,17.7,5.8c4.2,3.5,7.2,8.1,8.7,13.9h37.3c-3-13.7-9.6-25-19.5-33.6 C88.5,43,74,38.4,56.1,38.4c-17.6,0-31.3,4-40.8,12c-9.4,7.9-14.1,18.3-14.1,31c0,9.8,2.4,17.6,7.1,23.1 c4.8,5.7,10.6,9.9,17.2,12.4c6.9,2.6,15.8,5.2,26.5,7.5c11,2.6,19.1,5,24.1,7.3c5.7,2.7,8.6,7.2,8.6,13.4c0,4.6-1.6,8.5-4.7,11.3 c-3.1,2.8-7.5,4.3-13.2,4.3c-7.9,0-14.4-1.9-19.4-5.6c-4.7-3.4-7.6-8.3-8.7-14.4H0c2.9,14.7,9.7,26.2,20.4,34.3 c11.4,8.6,27,13,46.2,13c11.4,0,21.3-1.8,29.6-5.5c8.1-3.6,14.4-8.6,18.7-14.8c4.3-6.2,6.4-13.5,6.4-21.6c0-10-2.5-18-7.3-23.8 C109,116.4,103,112,96.2,109.4"/>
      <path fill="#122E79" d="M554.7,148.2C554.7,148.2,554.7,148.2,554.7,148.2c-2.9-2.8-4.3-7.3-4.3-13.8V77.2h29.5V44.2h-29.5V0h-40.2 v44.2h-19.7v33.1h19.7v56.3c0,18.8,4.6,32.4,13.5,40.4c9.1,8.1,22,12.1,38.5,12.1h17.9v-33.9h-11.8 C562,152.3,557.6,151,554.7,148.2"/>
      <path fill="#122E79" d="M712.7,75.3c0,0.4-0.3,0.8-0.7,0.9c-0.5,0.1-0.9-0.1-1.1-0.5l-2.8-6.4c-3.6-8.3-9.4-14.9-17-19.7 c-7.6-4.8-16.9-7.3-27.7-7.3c-11.6,0-22.1,2.9-31.2,8.7c-9.1,5.8-16.4,14.2-21.8,25.1c-5.3,10.9-8,24.1-8,39.1 c0,14.8,2.7,27.9,8,38.9c5.3,10.9,12.6,19.4,21.8,25.2c9.1,5.8,19.6,8.7,31.2,8.7c10.7,0,20-2.4,27.7-7.3 c7.6-4.8,13.3-11.4,17-19.7l2.8-6.4c0.2-0.4,0.6-0.6,1.1-0.5c0.4,0.1,0.7,0.5,0.7,0.9v31.1h39.9v-142h-39.9V75.3z M702.9,142.9 c-6.5,7-14.9,10.5-25,10.5c-10.3,0-18.7-3.4-25-10.2c-6.3-6.7-9.5-16.1-9.5-27.9c0-11.8,3.2-21.2,9.5-27.9 c6.3-6.8,14.7-10.2,25-10.2c10.1,0,18.5,3.5,25,10.4c6.5,6.8,9.7,16.2,9.7,27.8C712.7,126.6,709.4,135.9,702.9,142.9"/>
      <path fill="#00C473" d="M380.9,66.6c16.8,0,30.5-13.7,30.5-30.5c0-16.8-13.7-30.4-30.5-30.4c-16.8,0-30.4,13.7-30.4,30.4 C350.4,53,364.1,66.6,380.9,66.6"/>
      <path fill="#00C473" d="M385.1,95.2c-10.4,0.9-19.7-2.9-25.6-6.3c-16.9-9.6-28.6-27.1-30-44.7h-35.6c1.2,26.8,15.6,52.7,38.7,69.6 l1.4,1c0.2,0.2,0.4,0.4,0.4,0.7c0,0.3-0.1,0.5-0.3,0.7l-1.2,1.2c-24.1,24.2-34.8,55.3-38.5,68.8h37.2 c5.2-14.6,17.3-40.6,41.3-55.5l0.4-0.2c0.2-0.1,0.3-0.1,0.5-0.1h0l14.5,0.2c0.2,0,0.3,0.1,0.5,0.2l0.3,0.2 c23.7,14.9,35.8,40.8,41,55.4h37.3c-3.7-13.3-14.2-44.1-37.9-68.2l-1.2-1.2c-0.2-0.2-0.3-0.5-0.3-0.7c0-0.3,0.2-0.5,0.4-0.7l1.4-1 c5-3.7,9.6-7.9,13.8-12.6c14.3-16,22.9-36,24.2-56.5c0-0.4,0-0.7,0.1-1.1h-35.6C430.1,69.7,408.7,93,385.1,95.2"/>
      <rect fill="#122E79" x="226.9" y="44.2" width="40.2" height="142" />
      <rect fill="#122E79" x="150.8" width="40.2" height="186.2" />
      </svg>`
    }
  }

  setCbId = (cbId) => {
    this.cbId = cbId
  }

  render() {
    if (!this.container) {
      this.container = document.createElement('div')
      this.container.classList.add(this._CSS.block)
      ReactDOM.render(
        <MuiThemeProvider theme={theme}>
          <ReactComponent
            {...this.data}
            {...this.config}
            className={this._CSS.react}
            blockId={this.blockId}
            setCbId={this.setCbId}
          /></MuiThemeProvider>,
        this.container,
      )
    }
    return this.container
  }

  rendered() {
    console.log('SlixtaWidget was rendered')
  }

  moved() {
    console.log('SlixtaWidget was moved')
  }

  removed() {
    console.log('SlixtaWidget was removed')
    ReactDOM.unmountComponentAtNode(this.container)
  }

  save(element) {
    return {
      cbId: this.cbId
    }
  }
}

const Styles = StyleSheet.create({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 8,
    borderRadius: AppTheme.borderRadius,
    border: '1px solid ' + AppTheme.borderColor
  },
  title: {
    margin: 0
  }
})